// Used in resource.component.html

// Angular
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

// Services/Types/Helpers
import { AssignmentHelper } from "#helpers/assignment.helper";
import { AssetId } from "@carnegie-learning/common-types";
import { Asset, assetTypeIds } from "@carnegie-learning/cure-types";
import { AssetTypeHelper } from "cli-types";

@Component({
    selector: "page-banner",
    templateUrl: "./page-banner.component.html",
    styleUrls: ["./page-banner.component.scss"],
    standalone: false
})
export class PageBannerComponent implements OnInit {
    readonly assetTypeIds = assetTypeIds;

    @Input() selectedAsset: Asset;
    @Input() subTaskId: AssetId;
    @Input() selectedSubTask: Asset;
    @Input() fromAssignPreview: boolean;
    @Input() creatingLesson: boolean;
    @Input() showBannerOptions: boolean;
    @Input() assigned: boolean;
    @Input() selectedBundle?: Asset;
    @Input() showProfileMessaging?: boolean;

    @Output() goBackToAssignFn = new EventEmitter<void>();
    @Output() handleAssignClickFn = new EventEmitter<any>();

    constructor(
        private assignmentHelper: AssignmentHelper,
        private assetTypeHelper: AssetTypeHelper
    ) {}

    ngOnInit(): void {}

    goBackToAssign() {
        this.goBackToAssignFn.emit();
    }

    handleAssignClick() {
        this.assigned = !this.assigned;
        const payload = { assigned: this.assigned };
        this.handleAssignClickFn.emit(payload);
    }

    // Assignable Title
    getAssignableTitle(selectedAsset: Asset) {
        if (selectedAsset) {
            if (this.selectedSubTask) {
                return this.selectedSubTask.displayName;
            } else {
                return selectedAsset.displayName;
            }
        }
    }

    // Assignable Sub Title
    getAssignableSubTitle(selectedAsset: Asset) {
        if (selectedAsset && this.selectedSubTask && this.selectedBundle) {
            const bundleTypeName = this.assetTypeHelper.getCapTypeName(
                this.selectedBundle.assetActivityTypeId
            );
            return (
                `<span class='font-weight-300'>Included in the ${bundleTypeName}:</span> ` +
                this.selectedBundle.displayName
            );
        } else if (this.selectedAsset && this.selectedAsset.assetTypeId) {
            let assetType: string = this.selectedAsset.assetTypeId;
            if (this.selectedAsset.assetActivityTypeId) {
                assetType = this.selectedAsset.assetActivityTypeId;
            }
            return this.assetTypeHelper.getCapTypeName(assetType);
        }
    }

    getAssignTooltip(assigned: boolean) {
        if (assigned) {
            return "Remove from cart";
        } else if (!assigned && !this.creatingLesson) {
            return "Add to cart";
        } else if (
            !assigned &&
            this.creatingLesson &&
            this.selectedAsset.assetTypeId === assetTypeIds.BUNDLE
        ) {
            return "Cannot assign Bundles to cart while in Bundle creation mode";
        }
    }

    backLinkName() {
        if (this.selectedSubTask && this.selectedBundle) {
            const bundleTypeName = this.assetTypeHelper.getCapTypeName(
                this.selectedBundle.assetActivityTypeId
            );
            return `${bundleTypeName} Preview`;
        } else {
            return "Content Library";
        }
    }

    // Get the correct icon name to access it's svg icon
    getIconPath() {
        let assetType: string = this.selectedAsset.assetTypeId;
        if (this.selectedAsset.assetActivityTypeId) {
            assetType = this.selectedAsset.assetActivityTypeId;
        }

        return this.assetTypeHelper.convertShortAssignableTypeToIconPath(
            assetType
        );
    }

    // Get selected asset name
    getAssetName(item: Asset) {
        if (item) {
            return this.assignmentHelper.getAssetDisplayName(item);
        }
    }
    headBannerClassReturn(selectedAsset: Asset): string {
        let returnedCssClass = "";
        if (
            selectedAsset?.displayName &&
            selectedAsset.displayName.length > 80
        ) {
            returnedCssClass = "truncate";
        }
        return returnedCssClass;
    }
}
